import { inject } from '@angular/core';
import { AuthStore } from '../stores';
import { CanActivateFn, Router } from '@angular/router';

export function authGuard(redirectRoute: string): CanActivateFn {
  return () => {
    const authStore: AuthStore = inject(AuthStore);
    const router: Router = inject(Router);
    const canAccess = authStore.hasSession();

    if (!canAccess) return router.createUrlTree([redirectRoute]);

    return canAccess;
  };
}
